import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { FactoryReport } from 'src/app/models/report';
import { environment } from 'src/environments/environment';
import { Zone, Level, Shelve } from 'src/app/models/rack-management';

@Injectable({
  providedIn: 'root'
})
export class ManageRackService {
  constructor(private http: HttpClient) {}

  // Mock data for testing
  private mockZones: Zone[] = [
    {
      _id: '1',
      name: 'Zone A - Electronics',
      abbreviation: 'EL',
      createdAt: '2024-01-15T10:30:00Z',
      expanded: false
    },
    {
      _id: '2',
      name: 'Zone B - Clothing',
      abbreviation: 'CL',
      createdAt: '2024-01-16T14:20:00Z',
      expanded: false
    },
    {
      _id: '3',
      name: 'Zone C - Home & Garden',
      abbreviation: 'HG',
      createdAt: '2024-01-17T09:15:00Z',
      expanded: false
    }
  ];

  private mockLevels: Level[] = [
    // Zone A levels
    { _id: 'l1', level: 'Level 1', zone: '1', createdAt: '2024-01-15T11:00:00Z', expanded: false },
    { _id: 'l2', level: 'Level 2', zone: '1', createdAt: '2024-01-15T11:30:00Z', expanded: false },
    { _id: 'l3', level: 'Level 3', zone: '1', createdAt: '2024-01-15T12:00:00Z', expanded: false },
    
    // Zone B levels
    { _id: 'l4', level: 'Ground Floor', zone: '2', createdAt: '2024-01-16T15:00:00Z', expanded: false },
    { _id: 'l5', level: 'First Floor', zone: '2', createdAt: '2024-01-16T15:30:00Z', expanded: false },
    
    // Zone C levels
    { _id: 'l6', level: 'Indoor Section', zone: '3', createdAt: '2024-01-17T10:00:00Z', expanded: false },
    { _id: 'l7', level: 'Outdoor Section', zone: '3', createdAt: '2024-01-17T10:30:00Z', expanded: false }
  ];

  private mockShelves: Shelve[] = [
    // Level 1 shelves (Zone A)
    { _id: 's1', shelve: 'Shelf A1', level: 'l1', createdAt: '2024-01-15T11:15:00Z' },
    { _id: 's2', shelve: 'Shelf A2', level: 'l1', createdAt: '2024-01-15T11:20:00Z' },
    { _id: 's3', shelve: 'Shelf A3', level: 'l1', createdAt: '2024-01-15T11:25:00Z' },
    
    // Level 2 shelves (Zone A)
    { _id: 's4', shelve: 'Shelf B1', level: 'l2', createdAt: '2024-01-15T11:45:00Z' },
    { _id: 's5', shelve: 'Shelf B2', level: 'l2', createdAt: '2024-01-15T11:50:00Z' },
    
    // Level 3 shelves (Zone A)
    { _id: 's6', shelve: 'Shelf C1', level: 'l3', createdAt: '2024-01-15T12:15:00Z' },
    
    // Ground Floor shelves (Zone B)
    { _id: 's7', shelve: 'Rack 1', level: 'l4', createdAt: '2024-01-16T15:15:00Z' },
    { _id: 's8', shelve: 'Rack 2', level: 'l4', createdAt: '2024-01-16T15:20:00Z' },
    { _id: 's9', shelve: 'Rack 3', level: 'l4', createdAt: '2024-01-16T15:25:00Z' },
    
    // First Floor shelves (Zone B)
    { _id: 's10', shelve: 'Display 1', level: 'l5', createdAt: '2024-01-16T15:45:00Z' },
    { _id: 's11', shelve: 'Display 2', level: 'l5', createdAt: '2024-01-16T15:50:00Z' },
    
    // Indoor Section shelves (Zone C)
    { _id: 's12', shelve: 'Indoor Shelf 1', level: 'l6', createdAt: '2024-01-17T10:15:00Z' },
    { _id: 's13', shelve: 'Indoor Shelf 2', level: 'l6', createdAt: '2024-01-17T10:20:00Z' },
    
    // Outdoor Section shelves (Zone C)
    { _id: 's14', shelve: 'Outdoor Rack 1', level: 'l7', createdAt: '2024-01-17T10:45:00Z' },
    { _id: 's15', shelve: 'Outdoor Rack 2', level: 'l7', createdAt: '2024-01-17T10:50:00Z' }
  ];

  httpPost(url: string, data: any): Observable<any> {
    console.log('POST Mock Data:', url, data);
    
    // // Mock responses for different endpoints
    // if (url === 'FactoryZone') {
    //   const newZone: Zone = {
    //     _id: (this.mockZones.length + 1).toString(),
    //     name: data.name,
    //     createdAt: new Date().toISOString(),
    //     expanded: false
    //   };
    //   this.mockZones.push(newZone);
    //   return of({ success: true, message: 'Zone created successfully', data: newZone });
    // }
    
    // if (url === 'FactoryLevel') {
    //   const newLevel: Level = {
    //     _id: 'l' + (this.mockLevels.length + 1),
    //     level: data.level,
    //     zone: data.zone,
    //     createdAt: new Date().toISOString(),
    //     expanded: false
    //   };
    //   this.mockLevels.push(newLevel);
    //   return of({ success: true, message: 'Level created successfully', data: newLevel });
    // }
    
    // if (url === 'FactoryShelve') {
    //   const newShelve: Shelve = {
    //     _id: 's' + (this.mockShelves.length + 1),
    //     shelve: data.shelve,
    //     level: data.level,
    //     createdAt: new Date().toISOString()
    //   };
    //   this.mockShelves.push(newShelve);
    //   return of({ success: true, message: 'Shelve created successfully', data: newShelve });
    // }

    // Actual API call (commented for now)
    return this.http
      .post<{ data: any }>(`${environment.operational_url}${url}`, data)
      .pipe(map(res => res.data));
    
    // return of({ success: true, message: 'Mock response' });
  }

  httpGet(url: string, isOperational: boolean = true): Observable<any> {
    console.log('GET Mock Data:', url);
    
    // Mock responses for different endpoints
    // if (url === 'getFactoryZone') {
    //   return of({ data: this.mockZones });
    // }
    
    // if (url.startsWith('getFactoryLevel')) {
    //   const zoneId = url.split('zone=')[1];
    //   const levels = this.mockLevels.filter(level => level.zone === zoneId);
    //   return of({ data: levels });
    // }
    
    // if (url.startsWith('getFactoryShelve')) {
    //   const levelId = url.split('level=')[1];
    //   const shelves = this.mockShelves.filter(shelve => shelve.level === levelId);
    //   return of({ data: shelves });
    // }

    // Actual API call (commented for now)
    return this.http
      .get<{ data: any }>(`${isOperational ? environment.operational_url : environment.base_url}${url}`)
      .pipe(map(res => res.data));
    
    return of({ data: [] });
  }

  httpPut(url: string, data: any): Observable<any> {
    console.log('PUT Mock Data:', url, data);
    
    // Mock update operations
    // if (url.startsWith('FactoryZone/')) {
    //   const zoneId = url.split('/')[1];
    //   const zoneIndex = this.mockZones.findIndex(zone => zone._id === zoneId);
    //   if (zoneIndex !== -1) {
    //     this.mockZones[zoneIndex] = { ...this.mockZones[zoneIndex], ...data };
    //     return of({ success: true, message: 'Zone updated successfully', data: this.mockZones[zoneIndex] });
    //   }
    // }
    
    // if (url.startsWith('FactoryLevel/')) {
    //   const levelId = url.split('/')[1];
    //   const levelIndex = this.mockLevels.findIndex(level => level._id === levelId);
    //   if (levelIndex !== -1) {
    //     this.mockLevels[levelIndex] = { ...this.mockLevels[levelIndex], ...data };
    //     return of({ success: true, message: 'Level updated successfully', data: this.mockLevels[levelIndex] });
    //   }
    // }
    
    // if (url.startsWith('FactoryShelve/')) {
    //   const shelveId = url.split('/')[1];
    //   const shelveIndex = this.mockShelves.findIndex(shelve => shelve._id === shelveId);
    //   if (shelveIndex !== -1) {
    //     this.mockShelves[shelveIndex] = { ...this.mockShelves[shelveIndex], ...data };
    //     return of({ success: true, message: 'Shelve updated successfully', data: this.mockShelves[shelveIndex] });
    //   }
    // }

    // Actual API call (commented for now)
    return this.http
      .put<{ data: any }>(`${environment.operational_url}${url}`, data)
      .pipe(map(res => res.data));
    
    // return of({ success: true, message: 'Mock update response' });
  }

  httpDelete(url: string): Observable<any> {
    console.log('DELETE Mock Data:', url);
    
    // // Mock delete operations
    // if (url.startsWith('FactoryZone/')) {
    //   const zoneId = url.split('/')[1];
    //   const zoneIndex = this.mockZones.findIndex(zone => zone._id === zoneId);
    //   if (zoneIndex !== -1) {
    //     this.mockZones.splice(zoneIndex, 1);
    //     // Also remove related levels and shelves
    //     this.mockLevels = this.mockLevels.filter(level => level.zone !== zoneId);
    //     this.mockShelves = this.mockShelves.filter(shelve => {
    //       const levelExists = this.mockLevels.some(level => level._id === shelve.level);
    //       return levelExists;
    //     });
    //     return of({ success: true, message: 'Zone deleted successfully' });
    //   }
    // }
    
    // if (url.startsWith('FactoryLevel/')) {
    //   const levelId = url.split('/')[1];
    //   const levelIndex = this.mockLevels.findIndex(level => level._id === levelId);
    //   if (levelIndex !== -1) {
    //     this.mockLevels.splice(levelIndex, 1);
    //     // Also remove related shelves
    //     this.mockShelves = this.mockShelves.filter(shelve => shelve.level !== levelId);
    //     return of({ success: true, message: 'Level deleted successfully' });
    //   }
    // }
    
    // if (url.startsWith('FactoryShelve/')) {
    //   const shelveId = url.split('/')[1];
    //   const shelveIndex = this.mockShelves.findIndex(shelve => shelve._id === shelveId);
    //   if (shelveIndex !== -1) {
    //     this.mockShelves.splice(shelveIndex, 1);
    //     return of({ success: true, message: 'Shelve deleted successfully' });
    //   }
    // }

    // Actual API call (commented for now)
    return this.http
      .delete<{ data: any }>(`${environment.operational_url}${url}`)
      .pipe(map(res => res.data));
    
    // return of({ success: true, message: 'Mock delete response' });
  }
}
